module.exports = __webpack_public_path__ + "img/drug_enforcement-stage_5.2.2b2aa55a.jpg";